export default {
  apiKey: "AIzaSyBzurGwSbAQdFRFiJaEOojbS0yUPg2WErM",
  authDomain: "dime-erp.firebaseapp.com",
  projectId: "dime-erp",
  storageBucket: "dime-erp.appspot.com",
  messagingSenderId: "277307008225",
  appId: "1:277307008225:web:98eb098bc12c70df4503a0",
};
